/* globals google */
'use strict';

var formValidation = require('base/components/formValidation');
var baseStoreLocator = require('base/storeLocator/storeLocator');

var geocodingCountryCode = 'AU';

/**
 * appends params to a url
 *
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Init google map
 * @returns {Object} map - Google Maps Object
 */
function initMap() {
    var mapCanvas = document.querySelector('.map-canvas');
    geocodingCountryCode = mapCanvas.dataset.defaultcountrycode;
    var googleMapId = mapCanvas.dataset.mapid;
    var latlng = new google.maps.LatLng(Number(mapCanvas.dataset.defaultlat), Number(mapCanvas.dataset.defaultng)); // eslint-disable-line
    var mapOptions = {
         scrollwheel: false,
         zoom: 5,
         center: latlng,
         mapId: googleMapId
     };
     window.map = new google.maps.Map(mapCanvas, mapOptions);
     return window.map;
}

/**
 * This function is invoked when a store is selected by either clicking on the
 * - radio button from store results list OR
 * - clicking on the marker object
 *
 * @param {Object} map - Google map object
 * @param {Object} store  - Store object
 * @param {Object} mapMarker  - Google map Marker object
 * @param {Object} infowindow  - Google map InfoWindow object
 */
function selectStore(map, store, mapMarker, infowindow) {
    if (map.getZoom() < 16) {
        map.setZoom(16);
    }

    if (!map.getBounds().contains(mapMarker.getPosition())) {
        map.setCenter(mapMarker.getPosition());
    }

    infowindow.setOptions({
        content: store.infoWindowHtml
    });
    infowindow.open(map, mapMarker);
}

/**
 * Uses google maps api to render a map
 * @param {boolean} skipInit - whether to skip map init
 */
function updateMap(skipInit) {
    var mapCanvas = document.querySelector('.map-canvas');
    var map;
    if (!skipInit) {
        var googleMapId = mapCanvas.dataset.mapid;
        var latlng = new google.maps.LatLng(Number(mapCanvas.dataset.defaultlat), Number(mapCanvas.dataset.defaultng)); // eslint-disable-line
        var mapOptions = {
             scrollwheel: false,
             zoom: 5,
             center: latlng,
             mapId: googleMapId
         };
        map = new google.maps.Map(mapCanvas, mapOptions);
    } else {
        map = window.map;
    }
    var infowindow = new google.maps.InfoWindow();

    var mapdiv = $('.map-canvas').attr('data-locations');
    mapdiv = JSON.parse(mapdiv);
    var bounds = new google.maps.LatLngBounds();
    if (mapdiv.length) {
        if (mapdiv.length > 1) {
            Object.keys(mapdiv).forEach(function (key) {
                var item = mapdiv[key];
                var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
                var marker = new google.maps.Marker({
                    position: storeLocation,
                    map: map,
                    title: item.name
                });

                var storeDiv = document.getElementById('input-' + item.ID);
                if (storeDiv) {
                    storeDiv.addEventListener('click', function () {
                        selectStore(map, item, marker, infowindow);
                    });
                }

                marker.addListener('click', function () {
                    selectStore(map, item, marker, infowindow);
                    storeDiv.checked = true;
                });

                // Create a minimum bound based on a set of storeLocations
                bounds.extend(marker.position);
            });
            map.fitBounds(bounds);
        } else {
            var item = mapdiv[0];
            var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name
            });
            selectStore(map, item, marker, infowindow);
        }
    } else {
        initMap();
    }
}


/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $resultsDiv.hide();
        $('.store-locator-no-results').show();
    } else {
        $resultsDiv.show();
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }

    if ($mapDiv.data('has-google-api')) {
        updateMap(false);
    } else {
        $('.store-locator-no-apiKey').show();
    }
}

/**
 * This function gets the coordinates set within sessionStorage for the postal code entered by the customer.
 * This helps reduce the number of API calls to Google
 *
 * @param {*} postalCode - Postal code entered by customer
 * @returns {Object} Coordinates of the postal code
 */
function getPostalCodeCoordinatesFromSessionCache(postalCode) {
    try {
        let data = sessionStorage.getItem('storelocatorPostalCodeCoordinates');
        let postalCodeCoordinates = data ? JSON.parse(data) : {};
        if (postalCode in postalCodeCoordinates) {
            return postalCodeCoordinates[postalCode];
        }
    } catch (e) {
        // Session storage is not supported
    }
    return null;
}

/**
 * This function sets the coordinates returned by Google geocoding service for the postal code
 * entered by the customer within sessionStorage. This helps reduce the number of API calls to Google
 *
 * @param {*} postalCode - Postal code entered by customer
 * @param {*} latitude - Latitude coordinate
 * @param {*} longitude - Longitude coordinate
 */
function setPostalCodeCoordinatesInSessionCache(postalCode, latitude, longitude) {
    try {
        let data = sessionStorage.getItem('storelocatorPostalCodeCoordinates');
        let postalCodeCoordinates = data ? JSON.parse(data) : {};
        if (!(postalCode in postalCodeCoordinates)) {
            postalCodeCoordinates[postalCode] = {
                latitude: latitude,
                longitude: longitude
            };
        }
        sessionStorage.setItem('storelocatorPostalCodeCoordinates', JSON.stringify(postalCodeCoordinates));
    } catch (e) {
        // Session storage is not supported
    }
}

/**
 * This function searches for stores within SFCC using the postal code coordinates
 *
 * @param {*} $form - Form object
 * @param {*} latitude - Latitude coordinate
 * @param {*} longitude - Longitude coordinate
 * @param {*} method - Form method
 * @param {*} spinner  - Spinner object
 */
function searchStoresUsingCoordinates($form, latitude, longitude, method, spinner) {
    var radius;
    if ($('.js-option-selected').length > 0) {
        radius = $('.js-option-selected')[0].innerHTML;
    } else {
        radius = $('#radius').val();
    }
    var url = $form.attr('action');
    var urlParams = { radius: radius };
    if (latitude) {
        urlParams.lat = latitude;
    }
    if (longitude) {
        urlParams.long = longitude;
    }
    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: method,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 */
function search(element) {
	var frm = $('form[name="storelocator"]');
	formValidation(frm, {});
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    var $form = element.closest('.store-locator');
    var postalCode = $form.find('[name="postalCode"]').val();
    var formMethod = $form.attr('method');

    spinner.start();

    var postalCodeCoordinates = getPostalCodeCoordinatesFromSessionCache(postalCode);
    if (postalCodeCoordinates && postalCodeCoordinates.latitude && postalCodeCoordinates.longitude) {
        searchStoresUsingCoordinates($form, postalCodeCoordinates.latitude, postalCodeCoordinates.longitude, formMethod, spinner);
        return;
    }
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({
        componentRestrictions: {
            country: geocodingCountryCode,
            postalCode: postalCode
        }
    }, function (results) {
        var latitude = '';
        var longitude = '';
        if (results && (results.length > 0) && results[0].types.indexOf('country_code') === -1) {
            var coordinates = results[0].geometry.location.toJSON();
            latitude = coordinates.lat;
            longitude = coordinates.lng;
        } else {
            spinner.stop();
        }
        setPostalCodeCoordinatesInSessionCache(postalCode, latitude, longitude);

        searchStoresUsingCoordinates($form, latitude, longitude, formMethod, spinner);
    });
}


baseStoreLocator.init = function () {
    if ($('.map-canvas').data('has-google-api')) {
        var viewport = $(window).width();
        if (viewport >= 576) {
            initMap();
            updateMap(true);
        }
    } else {
        $('.store-locator-no-apiKey').show();
    }
};

baseStoreLocator.detectLocation = function () {
    // clicking on detect location.
    $('.detect-location').on('click', function () {
        $.spinner().start();
        if (!navigator.geolocation) {
            $.spinner().stop();
            return;
        }

        navigator.geolocation.getCurrentPosition(function (position) {
            var $detectLocationButton = $('.detect-location');
            var url = $detectLocationButton.data('action');
            var radius;
            if ($('.js-option-selected').length > 0) {
                radius = $('.js-option-selected')[0].innerHTML;
            } else {
                radius = $('#radius').val();
            }
            var urlParams = {
                radius: radius,
                lat: position.coords.latitude,
                long: position.coords.longitude
            };

            url = appendToUrl(url, urlParams);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $.spinner().stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    });
};

baseStoreLocator.search = function () {
    $('.store-locator-container form.store-locator').submit(function (e) {
        e.preventDefault();
        search($(this));
    });
    $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
        e.preventDefault();
        search($(this));
    });
};

baseStoreLocator.changeRadius = function () {
    $('.store-locator-container .radius').change(function () {
        var radius;
        if ($('.js-option-selected').length > 0) {
            radius = $('.js-option-selected')[0].innerHTML;
        } else {
            radius = $('#radius').val();
        }
        var searchKeys = $('.results').data('search-key');
        var url = $('.radius').data('action-url');
        var urlParams = {};

        if (searchKeys.postalCode) {
            urlParams = {
                radius: radius,
                postalCode: searchKeys.postalCode
            };
        } else if (searchKeys.lat && searchKeys.long) {
            urlParams = {
                radius: radius,
                lat: searchKeys.lat,
                long: searchKeys.long
            };
        }

        url = appendToUrl(url, urlParams);
        var dialog = $(this).closest('.in-store-inventory-dialog');
        var spinner = dialog.length ? dialog.spinner() : $.spinner();
        spinner.start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                spinner.stop();
                updateStoresResults(data);
                $('.select-store').prop('disabled', true);
            }
        });
    });
};

/**
 * Initialise common events that can be used for GoogleMaps storelocator
 * and GooglePlaces driven storelocator
 */
baseStoreLocator.events = function () {
    $('form.store-locator').on('custom:searchStoresUsingCoordinates', function (e, data) {
        var spinner = $.spinner();
        spinner.start();
        var $form = $('form.store-locator');
        searchStoresUsingCoordinates($form, data.latitude, data.longitude, 'get', spinner);
    });
};

module.exports = baseStoreLocator;
